import _ from 'lodash';

/**
 * Выполняет загрузку и подготовку аттачей захоронений
 * @param {Object} context Контекст Vuex
 * @param {Object} payload
 */
const pipeBurials = (context, payload) => new Promise((next) => {
  const data = payload;
  const payloadPipe = data.map((burial) => {
    const { photoAttaches } = burial;
    /** При редактировании объекта новые добавленные аттачи будут в виде 'object' */
    const photoAttachesToUpload = photoAttaches.filter((attach) => typeof attach === 'object');
    // eslint-disable-next-line consistent-return
    return new Promise((resolve) => {
      if (!photoAttachesToUpload || !photoAttachesToUpload.length) {
        return resolve([]);
      }
      const fd = new FormData();
      photoAttachesToUpload.map(({ file }, fileIndex) => fd.append(fileIndex, file));
      context.dispatch(
        'attachments/ACT_UPLOAD_ATTACHMENT',
        fd,
        { root: true },
      ).then((uploaded) => resolve(uploaded));
    });
  });
  /** Резолвим промис только после загрузки всех аттачей */
  return Promise.all(payloadPipe).then((output) => {
    // eslint-disable-next-line array-callback-return
    output.map((uploadedPhotoAttaches, index) => {
      data[index].photoAttaches = _(data[index].photoAttaches)
        .filter((obj) => typeof obj === 'number' || typeof obj === 'string')
        .concat(uploadedPhotoAttaches)
        .value();
    });
    return next(data);
  });
});

/**
 * Выполняет подготовку объекта перед сохранением
 * @param {Object} context Контекст Vuex
 * @param {Object} payload
 */
export const prepareSubjectPayload = (context, payload) => new Promise((next) => {
  const data = payload;
  let { photoAttach } = data;
  const { createBurials, updateBurials } = data;
  if (!data.family) {
    let burial = null;
    if (data?.updateBurials?.length) {
      [burial] = data.updateBurials;
    } else {
      [burial] = data.createBurials;
    }
    if (burial) {
      const { createPersons = [], updatePersons = {} } = burial;
      if (Object.keys(updatePersons).length) {
        data.name = updatePersons[Object.keys(updatePersons)[0]].name || '';
      } else if (createPersons.length) {
        data.name = createPersons[0].name || '';
      }
    }
  }
  // eslint-disable-next-line consistent-return
  return new Promise((resolve) => {
    if (!photoAttach || !photoAttach.length) {
      return resolve(null);
    }
    photoAttach = _.head(photoAttach);
    /** При редактировании объекта имеющийся будет в виде 'number' */
    if (typeof photoAttach === 'object') {
      const fd = new FormData();
      fd.append(0, photoAttach.file);
      return context.dispatch(
        'attachments/ACT_UPLOAD_ATTACHMENT',
        fd,
        { root: true },
      ).then((uploaded) => resolve(uploaded));
    }
    if (typeof photoAttach === 'number') {
      return resolve([photoAttach]);
    }
    resolve(null);
  }).then((uploadedPhotoAttach) => {
    data.photoAttach = _.head(uploadedPhotoAttach) || null;
    /** Соберем стэк промисов для обработки аттачей захоронений */
    const attachPipe = [];
    if (createBurials && !_.isEqual(createBurials, {})) {
      attachPipe.push(pipeBurials(context, createBurials).then((output) => {
        data.createBurials = output;
      }));
    }
    if (updateBurials && !_.isEqual(updateBurials, {})) {
      attachPipe.push(pipeBurials(context, updateBurials).then((output) => {
        data.updateBurials = output;
      }));
    }
    /** Резолвим промис только после обработки всех захоронений */
    return Promise.all(attachPipe).then(() => {
      const output = {
        name: data.name,
        family: data.family,
        celebrity: data.celebrity,
        cemetery: _.get(data, 'cemetery.id') || null,
        photoAttach: data.photoAttach,
        section: data.section,
        order: data.order,
        location: data.location,
        crypt: parseInt(data.crypt, 10) || null,
        size: _.get(data, 'size.value') || null,
        fence: _.get(data, 'fence.value') || null,
      };
      if (createBurials && !_.isEqual(createBurials, {})) {
        output.createBurials = createBurials.map((burial) => ({
          ...burial,
          headstone: _.get(burial, 'headstone.value') || null,
          pedestal: _.get(burial, 'pedestal.value') || null,
          flowerGarden: _.get(burial, 'flowerGarden.value') || null,
        }));
      }
      if (updateBurials && !_.isEqual(updateBurials, {})) {
        output.updateBurials = updateBurials.reduce((acc, burial) => {
          acc[burial.id] = {
            ...burial,
            headstone: _.get(burial, 'headstone.value') || null,
            pedestal: _.get(burial, 'pedestal.value') || null,
            flowerGarden: _.get(burial, 'flowerGarden.value') || null,
          };
          return acc;
        }, {});
      }
      next(output);
    });
  });
});

export default prepareSubjectPayload;
